// extracted by mini-css-extract-plugin
module.exports = {"Transparent_Blue_Button":"Transparent_Blue_Button_Transparent_Blue_Button__3sFMO","button_text":"Transparent_Blue_Button_button_text__33c_-"};